import { ModuleFE_RuntimeOrder } from './ModuleFE_RuntimeOrder.js';
export const ModulePackFE_RuntimeOrderDB = [ModuleFE_RuntimeOrder];
//# sourceMappingURL=module-pack.js.map